<template>
  <svg
    width="124"
    height="58"
    viewBox="0 0 124 58"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#0D93D2"
  >
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(44 1)" stroke-width="2">
        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
    <text
      font-family="Arial-BoldMT, Arial"
      font-size="12"
      font-weight="bold"
      fill="#302D2D"
      stroke="none"
    >
      <tspan x="0" y="54">{{ text }}</tspan>
    </text>
  </svg>
</template>

<script>
export default {
  name: 'Loading',
  props: ['text'],
};
</script>
